module.exports = __webpack_public_path__ + "img/rapyd.efa378c0.png";